<template>
  <div v-loading="loading">
    <div class="m-b-20 ovf-hd">
      <div class="fl" v-show="addShow">
        <span class="btn-link-large add-btn" @click="dialogVisible = true">
          <i class="el-icon-plus"></i>&nbsp;&nbsp;发起流程
        </span>
      </div>
			<div class="fl w-300 m-l-30" @keyup.enter="search()">
				<el-input v-model="keywords" placeholder="请输入关键词"></el-input>
			</div>
			<div class="fl m-l-20">
				<el-button type="primary" @click="search">搜索</el-button>
			</div>
    </div>
    <el-table :data="tableData" style="width: 100%" @selection-change="selectItem">
      <el-table-column type="selection" width="50">
      </el-table-column>
      <el-table-column prop="name" label="实例名称">
        <template scope="scope">
          <span>
            <router-link :to="{ name: 'flowDetail', params: { id: scope.row.flow_id }, query: { case_node_id: scope.row.case_node_id, case_id: scope.row.id }}" class="c-blue">
              {{ scope.row.name }}
            </router-link>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="realname" label="创建人">
      </el-table-column>
      <el-table-column type="create_time" label="创建时间">
        <template scope="scope">
          <span>{{ scope.row.create_time | parseTime }}</span>
        </template>
      </el-table-column>
      <el-table-column type="case_status" label="流程状态">
        <template scope="scope">
          <span>{{ scope.row.case_status }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template scope="scope">
          <div>
            <span v-show="scope.row.need_to_do == 1">
              <router-link :to="{ name: 'flowForm', params: { id: scope.row.flow_id }, query: { case_node_id: scope.row.case_node_id, case_id: scope.row.id }}" class="btn-link edit-btn m-r-5">
                处理
              </router-link>
            </span>
            <span v-show="false" class="btn-link edit-btn m-r-5">审批</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pos-rel p-t-20">
      <btnGroup :selectedData="multipleSelection" need="del" type="bpm/flowCases/deletes"></btnGroup>
      <div class="block pages">
        <el-pagination @current-change="handleCurrentChange" layout="prev, pager, next" :page-size="limit" :current-page="currentPage"
          :total="dataCount">
          </el-pagination>
      </div>
    </div>
    <el-dialog title="流程发起提示" v-model="dialogVisible" size="tiny">
      <span>是否发起一个流程？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="createFlow">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import btnGroup from '../../Common/normal/btn-group.vue'
  import http from '../../../assets/js/http'

  export default {
    data() {
      return {
        componentName: 'flowCaseList',
        flowId: null,
        tableData: [],
        dataCount: null,
        currentPage: null,
        keywords: '',
        multipleSelection: [],
        loading: false,
        limit: 15,
        dialogVisible: false
      }
    },
    filters: {
      parseTime(item) {
        return moment.unix(item).format('YYYY-MM-DD')
      }
    },
    methods: {
      search() {
        router.push({ name: 'flowCaseList', query: { keywords: this.keywords, page: 1 }})
      },
      selectItem(val) {
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ name: 'flowCaseList', query: { keywords: this.keywords, page: page }})
      },
      confirmDelete(item) {
        this.$confirm('确认删除该内容?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.apiDelete('', item.id).then((res) => {
            if (res.code == 200) {
              _g.toastMsg(this, 'success', '删除成功')
              setTimeout(() => {
                _g.reloadPage(this)
              }, 1500)
            } else {
              _g.dealError(this, res)
            }
          })
        }).catch(() => {
        })
      },
      getFlow() {
        this.loading = true
        let postData = {
          params: {
            keywords: this.keywords,
            page: this.currentPage,
            limit: this.limit
          }
        }
        this.apiGet(`bpm/flows/${this.flowId}/cases`, postData).then((res) => {
          this.loading = false
          if (res.code == 200) {
            this.tableData = res.data.list
            this.dataCount = res.data.dataCount
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      init() {
        this.getCurrentPage()
        this.getFlow()
      },
      createFlow() {
        this.apiPost(`bpm/flows/${this.flowId}/cases`).then((res) => {
          if (res.code == 200) {
            router.push({ name: 'flowForm', params: { id: this.flowId }, query: { case_id: res.data.caseId, case_node_id: res.data.startNodeId }})
          } else {
            _g.dealError(this, res)
          }
          this.dialogVisible = false
        })
      }
    },
    created() {
      this.flowId = this.$route.params.id
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('')
      },
      editShow() {
        return _g.getHasRule('')
      },
      designShow() {
        return _g.getHasRule('')
      },
      deleteShow() {
        return _g.getHasRule('')
      }
    },
    watch: {
      '$route'(to, from) {               // 监听路由改变
        this.flowId = to.params.id
        this.init()
      }
    },
    components: {
      btnGroup
    },
    mixins: [http]
  }

</script>


// WEBPACK FOOTER //
// list.vue?973d4102